<template>
  <div>

    <div class="selector">
      <button 
        v-if="selected"
        type="button"
        
        v-on:click="$emit('changeRoom')"
      >
        back
      </button>

      <button 
       v-if="selected == false"
        type="button"
        v-on:click="showTest('bitterbal')"
      >
        Show bitterbal
      </button>

      <button 
        v-if="selected == false"
        type="button"
        v-on:click="showTest('pickcard')"
      >
        Show html test
      </button>

      <button 
        v-if="selected == false"
        type="button"
        v-on:click="showTest('tingbuttons')"
      >
        Show Ting Buttons
      </button>

      <!-- <button 
        v-if="selected == false"
        type="button"
        v-on:click="showTest('styledwebcam')"
      >
        show Styled webcam
      </button> -->

      <button 
        v-if="selected == false"
        type="button"
        v-on:click="showTest('finalversion')"
      >
        Show Final Version
      </button>

    </div>

      <Bitterbal v-if="bitterBal"/>
      <PickCard 
        v-if="pickCard"
          :roomConnection="roomConnection"
          :loading="loading"
          :cameraOptions="cameraOptions"
          :reRenderRoom="reRender"
          :newRender="newRender"
        />

      <TingButtons 
        v-if="tingButtons"
        :roomConnection="roomConnection"
        :loading="loading"
        :cameraOptions="cameraOptions"
        :reRenderRoom="reRender"          
        />

      <!-- <StyledWebcam 
        v-if="styledWebcam"
          :roomConnection="roomConnection"
          :loading="loading"
          :cameraOptions="cameraOptions"
          :reRenderRoom="reRender"
          :newRender="newRender"
        /> -->

      <FinalVersion
        v-if="finalVersion"
        :roomConnection="roomConnection"
        :roomObject="roomObject"
        :reRenderRoom="reRender"
        :cameraOptions="cameraOptions"
        :username="username"
        :reRenderRemoteAudio="reRenderRemoteAudio"
      />

        
  </div>
</template>

<script>

  import Bitterbal from './Bitterbal'
  import PickCard from './PickCard'
  import TingButtons from './TingButtons'
  import StyledWebcam from './StyledWebcam'
  import FinalVersion from './FinalVersion'

  export default {
    name: 'YCTingResidency',
    props: ["roomConnection","loading","cameraOptions","reRender","reRenderRemoteAudio","roomObject","username"],
    components:{
      Bitterbal,
      TingButtons,
      PickCard,
      // StyledWebcam,
      FinalVersion,
    },

    data: function() {
      return {
        bitterBal: false,
        selected:true,
        pickCard:false,
        tingButtons:false,
        cameraOn:false,
        finalVersion:true,
        checkedServices:[],
        cameraChecked:false,
        cameraButtonDisabled:false,
        newRender:0,
        styledWebcam:false
      }
      
    },

    created: function() {
    },
    
    mounted: function() {
    },

    methods: {

      backToMain: function(){
        this.bitterBal = false; 
        this.selected = false;
        this.pickCard = false;
        this.tingButtons = false;
        this.finalVersion = false;
      },

      showTest: function(test){
        if(test === 'bitterbal' ){
          this.bitterBal = true; 
        }
        if(test === 'pickcard'){
          this.pickCard = true;
        }
        if(test === 'tingbuttons'){
          this.tingButtons = true;
        }
        if(test === 'styledwebcam'){
          this.styledWebcam = true;
        }
        if(test === 'finalversion'){
          this.finalVersion = true;
        }

        this.selected = true;

      },


    },

    computed: {
      rotate: function() {
        if (this.speed === '') {
          return 0
        } else {
          return this.speed
        }
      }
    },

    watch: {   
      reRender: function(){
        // console.log("rerender in TCTing");
        this.newRender +=1;

      }
    },

  }

</script>

<style>

  canvas{
    width: 500px;
    height: 500px;
  }

  #leaveRoom{
    position: fixed;
    bottom: 10px;
    right: 5%;
    z-index:1000;
    text-align: right;
    color:rgb(235, 235, 235);
    background-color: #464646;
  }

  #leaveRoom:hover{
    background-color:purple;
  }


  #controls{
    position: fixed;
    bottom: 10px;
    left: 5%;
    z-index:1000;
    text-align: left;
    background:green;
  }

  #controls div{
    color: white; 
  }

  #controls div:hover{
    /* background-color:purple; */
    /* color:white; */
  }

  #annotation{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    margin-left: 15px;
    margin-top: 15px;
    padding: 1em;
    width: 200px;
    color: #fff;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 4em;
    font-size: 12px;
    line-height: 1.2;
    transition: opacity .5s;
  }

  #annotation::before {
        content: 'IBO';
        position: absolute;
        top: -30px;
        left: -30px;
        width: 30px;
        height: 30px;
        border: 2px solid #fff;
        border-radius: 50%;
        font-size: 16px;
        line-height: 30px;
        text-align: center;
        background: rgba(0, 0, 0, 0.8);
    }


  .selector{
    position: fixed;
    z-index: 1000;
  }



  

</style>